import { FILTER_TYPES } from "../../../../utils/filter";

const filterConfig = [
  {
    placeholder: "Search roundtables by title",
    type: FILTER_TYPES.TEXT,
    filterTitle: "Title",
    dataField: "title",
  },
];

export default filterConfig;
